<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面收藏区域的内容区域样式   以上部分都是公共样式 -->
        <config-title-hang v-if="deviceATypeJudge()" class="config_hight_change_device_details">
          <span slot="config_title_hang_ele4">右击可删除一个设备对象</span>
          <img slot="config_title_hang_ele3" src="~assets/img/config/tishilaba.png" alt />
        </config-title-hang>

        <config-title-hang>
          <span slot="config_title_hang_ele2">{{ $route.query.title }}</span>
          <img slot="config_title_hang_ele5_img" src="~assets/img/config/soushuo_bai.png" @click="seekDeviceBtnHandle"
            alt />
          <span slot="config_title_hang_ele5" @click="seekDeviceBtnHandle">设备定位</span>
        </config-title-hang>

        <config-hang>
          <span slot="config_hang_ele2">设备的备注</span>
          <!-- img和input 配套使用 点击可以触发input的聚焦事件  v-model实际上是直接绑定的仓库数据信息 -->
          <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
          <input type="text" slot="config_hang_input_right" id="xiugaiName" placeholder="请输入备注名称"
            v-model="serveDeviceDetailsData.remark" />
        </config-hang>

        <config-title-hang>
          <span slot="config_title_hang_ele2">设备对象列表</span>
          <!-- //代号20220921-1 -->

          <img v-if="deviceATypeJudge()" slot="config_title_hang_ele5_img" src="~assets/img/config/add_baise.png"
            @click="addDeviceObjectBtnHandle" alt />
          <span v-if="deviceATypeJudge()" slot="config_title_hang_ele5" @click="addDeviceObjectBtnHandle">添加</span>

          <!-- 判断是否有添加按钮,有的话就往右排,没有就往左排  // 代号 20241212-1-->
          <span v-if="serveDeviceDetailsData.isBc && deviceATypeJudge()" slot="config_title_hang_ele6"
            @click="configDeviceBtnHandle">配置设备</span>
          <span v-if="serveDeviceDetailsData.isBc && !deviceATypeJudge()" slot="config_title_hang_ele5"
            @click="configDeviceBtnHandle">配置设备</span>


        </config-title-hang>

        <config-hang
          @click.native="oneDeviceObjectBtnHandle(value.deviceName, value.deviceId, serveDeviceDetailsData.productCode, serveDeviceDetailsData.productId)"
          v-for="(value, index) in serveDeviceDetailsData.dtList" :key="index"
          @contextmenu.prevent.native="deviceObjectRightClickBtnHandle(serveDeviceDetailsData.dtList, index)">
          <span slot="config_hang_ele2">{{ value.deviceName }}</span>
          <span slot="config_hang_ele3">{{ value.remark }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>

        <!--02 两路调光 014 F路调光 025 F双色控制  026 F三色控制 下载调光等级-->
        <div v-if="deviceObjectTypeJudge('02', '014', '025', '026', '029', '030')">
          <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
          <config-hang inputID="xiugaiName1">
            <span slot="config_hang_ele2">调光等级</span>
            <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
            <input type="text" slot="config_hang_input_right" id="xiugaiName1" placeholder="请输入调光等级（0-1000）"
              v-model="serveDeviceDetailsData.attributeOne" onkeyup="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')" />
          </config-hang>
          <config-hang @click.native="xaiZaiBtnHandle">
            <span slot="config_hang_ele_xia_zai">下载调光等级</span>
          </config-hang>

          <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
        </div>

        <!-- // 代号 20250207-1 -->
        <div class="xiaotishi_style">设备地址:[{{ serveDeviceDetailsData.borderAddress }}|{{
          serveDeviceDetailsData.borderInnerAddress }}|{{ serveDeviceDetailsData.address }}]</div>
        <div class="xiaotishi_style">当前设备产品码和信息码:[{{ serveDeviceDetailsData.productCode }}|{{
          serveDeviceDetailsData.program }}]</div>
        <div class="xiaotishi_style">关联的主机:[{{ serveDeviceDetailsData.uniqueCode16 }}|{{
          serveDeviceDetailsData.gatewayTypeName }}|{{
            serveDeviceDetailsData.gatewayName }}]</div>

        <!-- // 代号 20241212-1 -->


        <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">保存并返回</div>

        <!-- <config-hang @click.native="oneDeviceBtnHandle(1)">
          <span slot="config_hang_ele2">4路通断</span>
          <span slot="config_hang_ele3">主卧位置</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <config-hang @click.native="oneDeviceBtnHandle(2)">
          <span slot="config_hang_ele2">2路调光</span>
          <span slot="config_hang_ele3">主卧位置</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>-->
      </div>
    </div>
  </div>
</template>

<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
import {
  // deviceTypeJudge,
  // deviceTypeJudge1,
  publicDeviceTypeJudge
  // deviceStateFlip
} from "components/content/contro-view/device-view/device-item-view-js";
export default {
  data() {
    return {
      serveDeviceDetailsData: {
        address: 1,
        attributeOne: "",
        attributeTwo: "",
        dropTime: null,
        dtList: [
          {
            deleteState: 1,
            deviceId: "",
            deviceName: "",
            remark: ""
          }
        ],
        productCode: "",
        productId: "",
        remark: "",
        uniqueCode16: ""
      },
      ServeOneObjectinfo: {
        //一个对象页面的信息数据
        businessId1: "",
        businessId1Desc: "",
        businessId2: "",
        businessId2Desc: "",
        businessId3: "",
        businessId3Desc: "",
        businessId4: "",
        businessId4Desc: "",
        buttonCode: "",
        buttonId: "",
        buttonName: "",
        deleteState: 1, ////显示状态默认为1 显示
        deviceId: "",
        deviceName: "",
        deviceNo: "",
        gatewayId: "",
        gatewayNo: "",
        iconId: "",
        iconSuffix: "",
        iconUrl: "",
        list: [],
        passwordState: "",
        regionId: "",
        regionName: "",
        remark: ""
      }
    };
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    oneDeviceObjectBtnHandle(title, deviceId, productCode, productId) {
      ////一个设备对象按钮被点击了
      // 获取设备详情 接口，获取数据
      this.$request({
        method: "post",
        url: "/device/findDeviceById",
        data: {
          token: this.$store.state.token,
          deviceId: deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了 数据地址存到仓库
            this.$store.dispatch("asyUpdataServeOneObjectinfo", res.data.data); ///异步提交对象信息地址到仓库

            // 进入下一个页面
            this.$router.push({
              path: "deviceObjectDetails",
              query: {
                title: title,
                deviceId: deviceId,
                productCode: productCode,
                pageType: "config",
                productId: productId
              }
            });
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    seekDeviceBtnHandle() {
      ///   寻找设备按钮被点击了
      /// 寻找产品位置接口，获取数据
      this.$request({
        method: "post",
        url: "/product/productLocation",
        data: {
          token: this.$store.state.token,
          productId: this.serveDeviceDetailsData.productId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.serveDeviceDetailsData = res.data.data; ////拿到服务器返回的数据结果
            this.$showTipsToast(1, "定位成功~", true, 3000); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    addDeviceObjectBtnHandle() {
      ///添加设备对象按钮被点击了

      ////、控制成功了 数据地址存到仓库
      this.$store.dispatch(
        "asyUpdataServeOneObjectinfo",
        this.ServeOneObjectinfo
      ); ///异步提交对象信息地址到仓库
      // 进入下一个页面
      this.$router.push({
        path: "deviceObjectDetails",
        query: {
          title: "添加对象",
          deviceId: "",
          productCode: this.serveDeviceDetailsData.productCode,
          pageType: "configAdd",
          productId: this.serveDeviceDetailsData.productId
        }
      });
    },
    configDeviceBtnHandle() {
      //配置设备 按钮被点击胃
      //代号20220921-1
      // 代号 20241212-1
      // 进入下一个页面
      this.$router.push({
        path: "configDeviceList", query: {
          title: "配置功能列表",
          productId: this.serveDeviceDetailsData.productId,
          // bcId: this.serveDeviceDetailsData.bcId,
          productCode: this.serveDeviceDetailsData.productCode,
          program: this.serveDeviceDetailsData.program,
        }
      });

    },
    saveReturnBtnHandle() {
      ////保存并返回按钮按下了

      ///修改产品基础信息如昵称 接口，获取数据
      this.$request({
        method: "post",
        url: "/product/updateProductById",
        data: {
          token: this.$store.state.token,
          productId: this.serveDeviceDetailsData.productId,
          remark: this.serveDeviceDetailsData.remark,
          address: this.serveDeviceDetailsData.address
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.serveDeviceDetailsData = res.data.data; ////拿到服务器返回的数据结果
            // this.$showTipsToast(1, "保存成功", true); ////提示框
            this.$router.go(-1);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    deviceATypeJudge() {
      ///判断是否是A类型设备  是返回 true
      return publicDeviceTypeJudge(
        this.serveDeviceDetailsData.productCode,
        "06",
        "08",
        "010",
        "015",
        "017",
        "018",
        "022",
        "024"
      );
    },
    deviceObjectTypeJudge(...productCode) {
      ///判断是否是productCode类型设备  是返回 true
      return publicDeviceTypeJudge(
        this.serveDeviceDetailsData.productCode,
        ...productCode
      );
    },
    xaiZaiBtnHandle() {
      ////入参判断处理
      console.log(typeof this.serveDeviceDetailsData.attributeOne);
      if (this.serveDeviceDetailsData.attributeOne === "") {
        this.$toast("调光的等级不能为空");
        return;
      } else {
        let attributeOne = Number(this.serveDeviceDetailsData.attributeOne);
        if (attributeOne < 0 || attributeOne > 1000) {
          console.log(typeof attributeOne);
          this.$toast("调光的等级范围0-1000");
          return;
        }
      }

      ///设置调光等级 接口，获取数据
      this.$request({
        method: "post",
        url: "/product/updateDimmerRate",
        data: {
          token: this.$store.state.token,
          productId: this.serveDeviceDetailsData.productId,
          attributeOne: this.serveDeviceDetailsData.attributeOne
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.serveDeviceDetailsData = res.data.data; ////拿到服务器返回的数据结果
            this.$showTipsToast(1, "下载成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    deviceObjectRightClickBtnHandle(value, index) {
      console.log("设备对象右击了");

      if (
        this.deviceObjectTypeJudge(
          "017",
          "06",
          "08",
          "010",
          "015",
          "017",
          "018",
          "022",
          "024"
        )
      ) {
        // 只有上面这些设备才允许弹窗删除一个通道
        this.$showTipsToast(12, value, false, 1000, index);
      } else {
        console.log("设备对象右击了，但是该设备部允许执行删除");

      }

    }
  },

  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    // console.log(this.query.title);

    /// 获取产品详情接口，获取数据
    this.$request({
      method: "post",
      url: "/product/findProductById",
      data: {
        token: this.$store.state.token,
        productId: this.$route.query.productId
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveDeviceDetailsData = res.data.data; ////拿到服务器返回的数据结果
          console.log(this.serveDeviceDetailsData);
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style>
div .config_hight_change_device_details {
  height: 40px;
  line-height: 40px;
  margin-bottom: 8px;
}

div .config_hight_change_device_details img {
  right: 210px;
}
</style>
